// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E0q4","tabsBox":"styles_tabsBox__wY1Vc","createButton":"styles_createButton__24CcF"};